import { render, staticRenderFns } from "./EpisodesList.vue?vue&type=template&id=de09cfca&scoped=true"
import script from "./EpisodesList.vue?vue&type=script&lang=ts&setup=true"
export * from "./EpisodesList.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./EpisodesList.vue?vue&type=style&index=0&id=de09cfca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de09cfca",
  null
  
)

export default component.exports